import { CommonModule } from '@angular/common';
import {
  DOCUMENT,
  ModuleWithProviders,
  NgModule,
  inject,
  provideAppInitializer,
} from '@angular/core';

import { I18nService } from '@ts/shared/i18n/util-core';
import { UserStreamService } from '@ts/user/shared/data-access';

import { initI18nService } from './i18n-init';

@NgModule({
  imports: [CommonModule],
})
export class SharedI18nDataAccessModule {
  static forRoot(): ModuleWithProviders<SharedI18nDataAccessModule> {
    return {
      ngModule: SharedI18nDataAccessModule,
      providers: [
        provideAppInitializer(() => {
          const initializerFn = initI18nService(
            inject(UserStreamService),
            inject(I18nService),
            inject(DOCUMENT),
          );
          return initializerFn();
        }),
      ],
    };
  }
}
